import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import BackgroundAnimation from "../components/BackgroundAnimation";
import { toast } from "react-toastify";

function CTSHYLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await login({ username, password });

      if (response.token) {
        localStorage.setItem("user", JSON.stringify(response.user));
        // Navigate to dashboard with user info
        navigate("/dashboard", {
          state: {
            user: response.user,
            token: response.token,
          },
        });
      }
      toast.success("Login successful!");
    } catch (error) {
      console.error("Login error:", error);
      setError(error.error || "Invalid username or password");
      toast.error(error.error || "Invalid username or password");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <>
      <BackgroundAnimation />
      <div className="login-container">
        <form onSubmit={handleLogin} className="login-form">
          <h2 className="login-title">CLURXSAIFY Login</h2>
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter Username"
              required
              disabled={isLoading}
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
              required
              disabled={isLoading}
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
          {error && <p className="error-message">{error}</p>}
          <p className="contact-info">
            please contact ceo of clurxsaify for login details
          </p>
          <button
            type="button"
            className="back-button"
            onClick={handleBack}
            disabled={isLoading}
          >
            Back to Home
          </button>
        </form>
      </div>
    </>
  );
}

export default CTSHYLoginPage;
